var _circle, _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3, _ellipse4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound44AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 12,
  fill: "#464D57"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.142,
  cy: 15.858,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(135 44.142 15.858)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m39.192 12.322.707-.707c1.953-1.952 5.435-1.636 7.779.707 2.343 2.344 2.66 5.826.707 7.779l-.707.707"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.858,
  cy: 44.142,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-45 15.858 44.142)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m20.808 47.678-.707.707c-1.953 1.952-5.435 1.636-7.778-.707-2.344-2.344-2.66-5.826-.708-7.779l.707-.707"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.858,
  cy: 15.858,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(45 15.858 15.858)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m12.322 20.808-.707-.707c-1.952-1.953-1.636-5.435.707-7.778 2.344-2.344 5.826-2.66 7.779-.708l.707.707"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.142,
  cy: 44.142,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-135 44.142 44.142)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m47.678 39.192.707.707c1.952 1.953 1.636 5.435-.707 7.779-2.344 2.343-5.826 2.66-7.779.707l-.707-.707"
})));
SvgRound44AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound44AError);
export default ForwardRef;